import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { handleAd } from '@ifeng/ui_pc_ad';

class FinanceVideo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        ad: PropTypes.object,
    };

    ref = React.createRef();

    async componentDidMount() {
        const { ad } = this.props;

        const callbackFn = await handleAd(ad);

        callbackFn(this.ref.current, ad.data);
    }

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.financeVideo}>
                <a href={content[0].url} target="_blank" title={content[0].title}>
                    <p>
                        <img className={styles.trans} src={content[0].thumbnail} alt="" />
                        <span>{content[0].title}</span>
                    </p>
                </a>
                <ul className={styles.list} ref={this.ref}>
                    {content.slice(1).map((item, index) => (
                        <li key={index}>
                            <a href={item.url} target="_blank" title={item.title}>
                                {item.title}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(FinanceVideo);
